import  { useState, useEffect } from 'react';

import bannerImage1 from '../../assets/B1.jpg';
import bannerImage2 from '../../assets/B2.jpg';
import bannerImage3 from '../../assets/B3.jpg';
import bannerImage4 from '../../assets/B4.jpg';

const originalBannerImages = [
  bannerImage1,
  bannerImage2,
  bannerImage3,
  bannerImage4,
];

const bannerImages = [...originalBannerImages, originalBannerImages[0]];

const About = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        if (prevIndex === originalBannerImages.length - 1) {
          setIsTransitioning(true);
          setTimeout(() => {
            setIsTransitioning(false);
            setCurrentImageIndex(0);
            setTimeout(() => setIsTransitioning(true), 50);
          }, 5000);
          return prevIndex + 1;
        } else {
          setIsTransitioning(true);
          return (prevIndex + 1) % originalBannerImages.length;
        }
      });
    }, 2000); // Image display time: 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="about"
      // Adjust scroll-mt-value to match your navbar's height so it's not cut off.
      className="py-7 px-[7vw] md:px-[7vw] lg:px-[20vw] font-sans mt-px scroll-mt-20"
    >
      <div className="flex flex-col items-center gap-8">

        {/* TOP SECTION: One-by-One Image Slider (Horizontal Scroll) */}
        <div
          // MODIFIED: Set fixed width and height to 512px.
          // This will make the container exactly 512x512 pixels.
          // The image inside (with object-cover) will fill this square, cropping if needed.
          // Consider if you want this fixed pixel size on all screen sizes (mobile, desktop).
          // You might need responsive classes like w-[300px] h-[300px] md:w-[512px] md:h-[512px]
          // if you want it smaller on mobile.
          className="relative overflow-hidden bg-transparent w-[212px] h-[198px]"
        >
          {bannerImages.map((image, index) => (
            <img
              key={index}
              src={image} // The src now points to the Base64 data string.
              alt={`Food-Square Resturatnt Banner ${index + 1}`}
              // Keep object-cover to ensure the 512x512 space is always fully covered.
              // This WILL cause cropping if the image's original aspect ratio is not 1:1.
              className={`absolute top-0 left-0 w-full h-full object-cover block
                ${isTransitioning ? 'transition-transform duration-2000 ease-in-out' : 'transition-none'}
                ${index === currentImageIndex ? 'translate-x-0' :
                  index < currentImageIndex ? '-translate-x-full' : 'translate-x-full'
                }`}
            />
          ))}
        </div>

        {/* BOTTOM SECTION: Text Content for Food-Square Resturatnt */}
        <div className="w-full text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-4 leading-tight">
           𝑾𝒆𝒍𝒄𝒐𝒎𝒆 𝒕𝒐 🍟 Food-Square & Restaurant ​ 🍮
          </h1>

          {/* Call to Action Button */}
          <a
            href="#products"
            className="inline-block text-white py-8 px-12 rounded-full mt-5 text-lg font-bold transition duration-300 transform hover:scale-105"
            style={{
              background: 'linear-gradient(90deg, #8245ec, #a855f7)',
              boxShadow: '0 0 2px #8245ec, 0 0 2px #8245ec, 0 0 40px #8245ec',
            }}
          >
            EXPLORE OUR MENU
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;